import { Effect, Request, RequestResolver } from 'effect';
import { AuthoringError } from '../authoringService';
import * as Url from '../../../url';
export class PutTemplate extends Request.TaggedClass('@fixtuur/GavelTemplatesAuthoringService/PutTemplate') {
}
export const makePutTemplateResolver = (http) => RequestResolver.fromEffect((request) => {
    const url = Url.join(request.baseUrl, `/api/v1/${request.tenantId}/templates/${request.templateId}`);
    return http
        .put(url, { authorization: request.token, 'content-type': 'application/json' }, JSON.stringify(request.template))
        .pipe(Effect.catchAll(originalError => new AuthoringError({ originalError })), Effect.flatMap(_ => Effect.void));
});
